import React, { Component } from 'react';
import {Map, Marker, GoogleApiWrapper} from 'google-maps-react';
import { Link } from 'react-router-dom';
import './Dojo.css';
import { DojoRepository } from '../data/DojoRepository';

class Levis extends Component {
  render() {
    return (
        <div class="container page-content">
            <div id="dojoHeader">
                <img id="ShotokanLogo" alt="Logo du karaté Shotokan" src="/images/logos/Shotokan.png" />
            </div>
            <article id="dojoContent">
                <section id="dojoDescription"> 
                    <h1>{DojoRepository.LEVIS.name}</h1>
                    <p>C’est le 23 juin 1987 qu’a débuté l’histoire du dojo de karaté shotokan de Lévis. Avant sa vocation martiale, ce modeste local avait d’abord été occupé par la pharmacie Samson et ensuite par un bar nommé «&nbsp;l’Alcions&nbsp;». Après plusieurs mois d’efforts et de persévérance, les travaux de rénovation ont été complétés et le premier cours a eu lieu le 25 janvier 1988 à 19h30.</p>
                    <p>En fondant ce dojo, Sensei Robin Maheux a alors matérialisé un rêve de jeunesse, celui de transmettre sa passion pour le karaté et de faire valoir l’importance de s’entraîner quotidiennement dans un lieu habité par un &nbsp;esprit martial.</p>
                    <p>&nbsp;</p>
                    <h1><strong>Un dojo traditionnel</strong></h1>
                    <p>&nbsp;Le dojo est un lieu d’entraînement physique et de développement personnel. En faisant vivre et respecter le Dojo Kun, un code de conduite aussi strict que noble, Sensei Maheux perpétue les plus anciennes traditions d’enseignement des arts martiaux.&nbsp;Le respect de soi-même et le respect de l’adversaire sont à la base du karaté et ces notions fondamentales ont une place prédominante dans le dojo.</p>
                    <p>Cette philosophie influence directement l’ambiance de chaque entraînement. La rigueur et la discipline sont de mise, permettant aux élèves de développer leurs techniques en recherchant le parfait équilibre entre le corps et l’esprit.&nbsp;La maîtrise de l’art et la maîtrise de soi permettent &nbsp;d'évaluer la progression de chaque élève, beaucoup plus que ne peut le faire la couleur de leurs ceintures.</p>
                    <p>La participation à différentes compétitions n’est pas exclue mais laissée à la discrétion des élèves. Ces évènements font office de laboratoire leur permettant de mesurer l’efficacité de leurs techniques et de continuer à apprendre en étudiant leurs adversaires. Le dépassement de soi étant toujours une réalisation &nbsp;plus gratifiante que l'obtention d'une médaille.</p>
                    <p>&nbsp;</p>
                    <h1><strong>De nombreux élèves</strong></h1>
                    <p>Dès son ouverture, le dojo a attiré un grand nombre d’élèves pour des raisons aussi nombreuses que variées&nbsp;: curiosité, forme physique, motivations personnelles, autodéfense, esprit martial, etc… Au cours des 25 dernières années, plus de 1725 élèves ont fréquenté cette école qui n’a jamais eu de visée commerciale. Parmi ces 1725 élèves, 17 se sont mérités le grade de 1<sup>er</sup> dan, symbolisé par la ceinture noire.</p>
                    <p>Au fil des ans, le dojo a également accueilli de grands noms du karaté Shotokan, notamment Sensei James Field 8<sup>e</sup> Dan de Santa Monica en Californie, Sensei Seike 6<sup>e</sup> Dan d’Ottawa au Canada ainsi que le fils de Sensei Tanaka.</p>
                    <p>&nbsp;</p>
                    <h1><strong>Un dojo tourné vers l’avenir</strong></h1>
                    <p>Grâce à l’expertise et l’implication de deux autres instructeurs, Stéphane Michaud 4<sup>e</sup> dan et Marco Maheux 2<sup>e</sup> dan, Sensei Maheux poursuit son objectif de faire vivre l’esprit martial du karaté Shotokan et de faire évoluer ce style. Il peut également compter sur la collaboration de Sensei Denis Houde 7<sup>e</sup> Dan, chef instructeur de Québec ISKF, qui a toujours été à l’affût des besoins du dojo de Lévis.</p>
                    <p>Décortiquer toutes les applications de cet art martial représente le travail d’une vie. Le dojo de karaté Shotokan de Lévis est donc un lieu de développement personnel ou l’entraînement permet à chacun de trouver sa voie.</p>
                    <p>&nbsp;</p>
                </section> 

                <section id="dojoSchedule"> 
                    <h1>Horaire</h1>
                    <p><strong>Lundi</strong></p>
                    <p>18h00 à 19h00</p>
                    <p><strong>Mercredi</strong></p>
                    <p>18h00 à 19h00</p>
                    <p><strong>Vendredi</strong></p>
                    <p>18h00 à 19h00</p>
                </section>
                <p>&nbsp;</p>

                <section id="dojoPrices"> 
                    <h1>Tarifs</h1>
                    <table border="1" class="price-table"  cellSpacing="1" cellPadding="1">
                        <tbody>
                            <tr>
                                <td>Durée</td>
                                <td>Adultes</td>
                                <td>Enfants</td>
                            </tr>
                            <tr>
                                <td>1 session, 3 mois</td>
                                <td>65$</td>
                                <td>55$</td>
                            </tr>
                        </tbody>
                    </table>
                    <p>&nbsp;</p>
                </section> 
                <p>Bienvenue aux 7 à 77 ans!</p>
                <p>&nbsp;</p>

                <section id="dojoContacts"> 
                    <h1>Pour nous joindre</h1>
                    <p>
                        <strong>{DojoRepository.LEVIS.name}</strong><br />
                        {DojoRepository.LEVIS.address.line1}<br />
                        {DojoRepository.LEVIS.address.city}<br />
                        {DojoRepository.LEVIS.address.postalCode}<br />
                        <a href={DojoRepository.LEVIS.links.googleMaps} target="_blank" rel="noopener noreferrer" title={DojoRepository.LEVIS.name}>Google Maps</a>
                    </p>
                    <p>
                        <strong>{DojoRepository.LEVIS.contact.robin.fullName}</strong><br />
                        {DojoRepository.LEVIS.contact.robin.phone1}<br />
                        <span class="link-like">{DojoRepository.LEVIS.contact.robin.email1}</span><br />
                        <span class="link-like">{DojoRepository.LEVIS.contact.robin.email2}</span>
                    </p>
                </section> 
                <p>&nbsp;</p>
                
                <section id="dojo-map">
                    <Map
                        google={this.props.google}
                        initialCenter={DojoRepository.LEVIS.geo}>
                        <Marker position={DojoRepository.LEVIS.geo} />
                    </Map>
                </section> 
            </article>
            <Link class="returnToDojoRepository" to="/dojo">Retour au repertoire des Dojos</Link>
        </div>
    );
  }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyCqdJMLfuasXIr2gfxOzJyfP1gXVQt5-H8")
})(Levis);



// WEBPACK FOOTER //
// ./src/pages/dojo/Levis.js